import React, { useState, useEffect } from 'react';
import './ProgressBar.css';
import { useNavigate } from 'react-router-dom';

interface ProgressBarProps {
  percentage: number;
  title: string;
  imageUrl: string;
  id: string;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ percentage, title, imageUrl, id }) => {
  const [displayPercentage, setDisplayPercentage] = useState(0);
  const [isPulsing, setIsPulsing] = useState(false);
  const isOver50 = percentage > 50;
  const isHighWinRate = percentage > 89;
  const animationDuration = 1500;
  const navigate = useNavigate();

  const handleClick = () => {
    localStorage.setItem('title_img', imageUrl)
    navigate(`/NH/table/${id}`);
  };

  useEffect(() => {
    let start: number;
    const initialValue = isOver50 ? 20 : 80;
    const endValue = percentage;
    const duration = animationDuration;

    const animate = (timestamp: number) => {
      if (!start) start = timestamp;
      const progress = Math.min((timestamp - start) / duration, 1);
      const currentValue = initialValue + (endValue - initialValue) * progress;
      setDisplayPercentage(Math.floor(currentValue));

      if (progress < 1) {
        requestAnimationFrame(animate);
      } else if (percentage > 89) {
        setIsPulsing(true);
      }
    };

    requestAnimationFrame(animate);

    return () => {
      setIsPulsing(false);
    };
  }, [percentage, isOver50]);

  return (
    <div className="progress-container flex flex-col gap-4 p-5 m-2 w-full bg-gradient-to-br from-gray-800 to-gray-900 rounded-xl shadow-lg text-white transition-all duration-300">
      <div className="flex items-start justify-between w-full gap-4">
        <img
          className={`${isHighWinRate ? 'game-image-animation' : ''} game-image png-image w-24 h-24 object-cover rounded-lg transition-all duration-300 ${isHighWinRate && isPulsing ? 'animate-pulse-scale' : ''}`}
          src={imageUrl}
          alt={title}
        />
        <div className="flex-1 flex flex-col">
          <div className="flex flex-col text-center">
            <p className='font-bold pb-3'>Tỷ lệ thắng</p>
            <div className={`progress-percentage text-center text-2xl font-bold
              ${isHighWinRate ? 'text-yellow-400 animate-pulse-text' : 'text-teal-400'}`}>
              {displayPercentage}%
            </div>
            <button 
              type="button"
              onClick={handleClick}
              className={`${isHighWinRate ? 'buttonItemRun' : 'buttonItemSuggest'} buttonItem font-bold mt-2 px-4 py-1 bg-blue-600 rounded transition`}>
              {isHighWinRate ? 'Chạy' : 'Gợi ý'}
            </button>
          </div>
        </div>
      </div>
      <h3 className="progress-title text-base font-semibold text-gray-100 line-clamp-2">
        {title}
      </h3>
      <div className="progress-bar-wrapper w-full h-3 bg-gray-700 rounded-full overflow-hidden shadow-inner">
        <div className={`progress-fill h-full rounded-full transition-[width] duration-100 ease-out relative overflow-hidden ${isOver50 ? 'bg-gradient-to-r from-green-500 to-green-600' : 'bg-gradient-to-r from-red-500 to-yellow-600'
          } ${isHighWinRate && isPulsing ? 'animate-pulse-glow' : ''}`}
          style={{ width: `${displayPercentage}%` }}>
          <div className="absolute inset-0 bg-gradient-to-r from-white/10 via-white/30 to-white/10 animate-shine" />
          <span className="absolute left-1/2 top-1/2 -translate-y-1/2 text-xs font-bold text-white mix-blend-overlay">
            {displayPercentage}%
          </span>
        </div>
      </div>
    </div>
  );
};

export default ProgressBar;